import { buildProps } from '@element-plus/utils'
import type WatermarkV2 from './watermark.vue'
import type { ExtractPropTypes, PropType } from 'vue'
import type { WatermarkV2FontPartial } from '@element-plus/hooks'

export const watermarkV2Props = buildProps({
  image: {
    type: [
      String,
      Object as PropType<HTMLImageElement | HTMLCanvasElement | SVGElement>,
    ],
  },
  content: {
    type: [String, Array as PropType<string[]>],
  },
  width: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 0,
  },
  fillStyle: {
    type: String,
  },
  textAlign: {
    type: String,
    values: ['left', 'right', 'center', 'start', 'end'],
    default: 'center',
  },
  textBaseline: {
    type: String,
    values: ['top', 'hanging', 'middle', 'alphabetic', 'ideographic', 'bottom'],
    default: 'middle',
  },
  font: {
    type: [String, Object as PropType<WatermarkV2FontPartial>],
  },
  globalAlpha: {
    type: Number,
  },
  repeat: {
    type: String,
    values: ['no-repeat', 'repeat', 'repeat-x', 'repeat-y'],
    default: 'repeat',
  },
  rotate: {
    type: Number,
  },
  gap: {
    type: [Number, Array as PropType<number[]>],
    default: () => [100, 100],
  },
  debounce: {
    type: Number,
    default: 300,
  },
  zIndex: {
    type: Number,
    default: 3,
  },
  offset: {
    type: [Number, Array as PropType<number[]>],
  },
} as const)

export type WatermarkV2Props = ExtractPropTypes<typeof watermarkV2Props>
export type WatermarkV2Instance = InstanceType<typeof WatermarkV2>
